$ = require 'jquery'
Auth = require 'db/auth'
Controller = require 'controller'
CreateOrgView = require 'views/organization/create-org-view'
PopOver = require 'views/lib/pop-over'
React = require 'react'
Storage = require 'lib/storage'
Util = require 'lib/util'
getExperiment = require 'lib/experiments/simple-test'
t = require('views/internal/recup-with-helpers')('home')
trackUe = require 'debug/trackUe'
{ Navigation } = require './presentational/navigation'

module.exports = class HomeLeftSidebarContainer extends React.Component
  displayName: 'HomeLeftSidebarContainer'

  constructor: (props) ->
    super(props)
    @onCreateTeamClick = @onCreateTeamClick.bind(@)
    @setLastTab = @setLastTab.bind(@)

    @onCardsClick = @trackSubLinkClick.bind(@, 'shows', 'team cards', 'team cards')
    @onTeamHighlightsClick = @trackSubLinkClick.bind(@, 'shows', 'team feeds', 'team highlights')
    @onViewBoardsClick = @trackSubLinkClick.bind(@, 'shows more', 'boards', 'all team boards')
    @onMembersClick = @trackSubLinkClick.bind(@, 'opens', 'members', 'members')
    @onSettingsClick = @trackSubLinkClick.bind(@, 'opens', 'settings', 'settings')

  trackSubLinkClick: (verb, directObj, buttonName) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id
    method = "by clicking #{buttonName} in left sidebar when filtered by team"
    context = { teamId: orgId }
    trackUe('home', verb, directObj, '', '', method, context)

  onCreateTeamClick: (e) ->
    Util.preventDefault(e)

    { orgname, model, modelCache } = @props

    orgId = modelCache.findOne('Organization', 'name', orgname)?.id
    method =
      if orgId
      then 'by clicking create team in left sidebar when filtered by team'
      else 'by clicking create team in left sidebar'
    context = if orgId then { teamId: orgId } else {}
    trackUe('home', 'opens', 'create team menu', '', '', method, context)

    PopOver.toggle
      elem: $(e.currentTarget)
      view: CreateOrgView
      options: {
        model: model
        modelCache: modelCache
        trackingOpts:
          category: 'home'
          method: 'by clicking create team in left sidebar'
      }

  setLastTab: (url) ->
    Storage.set("home_#{Auth.myId()}_last_tab_2", url)

  render: t.renderable ->
    { modelCache, orgname, allBoards, orgBoards, orgCards } = @props
    member = modelCache.get('Member', Auth.myId())
    username = member?.get('username')
    orgs = member?.getSortedOrgs()
    pathname = window.location.pathname
    urlHome = '/'
    urlBoards = "/#{username}/boards"
    superHomeTeamCards = getExperiment('superHomeTeamCards').get('enabled')

    t.tag Navigation,
      className: 'home-left-sidebar-container'

      homeTab:
        href: urlHome
        selected: !orgname && !Boolean(allBoards)
        onClick: =>
          @setLastTab(urlHome)
          trackUe('home', 'shows', 'home feeds', '', '', 'by clicking home in left sidebar')

      boardsTab:
        href: urlBoards
        selected: Boolean(allBoards)
        onClick: =>
          @setLastTab(urlBoards)
          trackUe('home', 'shows', 'boards', '', '', 'by clicking boards in left sidebar')

      teamTabs: orgs.map (org) =>
        name = org.get('name')
        displayName = org.get('displayName')
        logoHash = org.get('logoHash')
        homeUrl = "/#{name}/home"
        linkTabs = []
        if orgname
          orgHighlightsUrl = "/#{name}/highlights"
          orgCardsUrl = "/#{name}/cards/due"
          orgBoardsUrl = Controller.getOrganizationUrl(orgname)
          orgMembersUrl = Controller.getOrganizationMembersUrl(orgname)
          orgAccountUrl = Controller.getOrganizationAccountUrl(orgname)
          linkTabs = [
            { key: '1', displayName: t.l('highlights'), iconName: 'heart', href: orgHighlightsUrl, onClick: @onTeamHighlightsClick, selected: !Boolean(orgBoards) && !Boolean(orgCards) }
            { key: '2', displayName: t.l('home-all-team-boards'), iconName: 'board', href: orgBoardsUrl, onClick: @onViewBoardsClick, external: true }
            { key: '3', displayName: t.l('home-view-members'), iconName: 'organization', href: orgMembersUrl, onClick: @onMembersClick, external: true }
            { key: '4', displayName: t.l('home-view-settings'), iconName: 'gear', href: orgAccountUrl, onClick: @onSettingsClick, external: true }
          ]

          if superHomeTeamCards
            linkTabs.unshift { key: '0', displayName: t.l('cards'), iconName: 'card', href: orgCardsUrl, onClick: @onCardsClick, selected: Boolean(orgCards) }

        return {
          key: org.id
          href: homeUrl
          selected: name == orgname && Boolean(orgBoards)
          expanded: name == orgname
          displayName: displayName
          logoUrl1x: logoHash && "#{window.logoDomain}/#{logoHash}/30.png"
          logoUrl2x: logoHash && "#{window.logoDomain}/#{logoHash}/170.png"
          linkTabs
          onClick: =>
            @setLastTab(homeUrl)
            trackUe('home', 'shows', 'team feeds', '', '', 'by clicking team name in left sidebar', 'teamId': org.id)
        }

      createTeamTab:
        onClick: @onCreateTeamClick



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-left-sidebar-container.coffee